import Extend from 'flarum/common/extenders';
import Tag from './models/Tag';
import TagGambit from './query/discussions/TagGambit';
import LabelGambit from './query/discussions/LabelGambit';
export default [new Extend.Store() //
.add('tags', Tag), new Extend.Search() //
.gambit('discussions', LabelGambit).gambit('posts', LabelGambit).gambit('discussions', TagGambit)];